/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import classes from "./subscriptionAdjustment.module.css";
import SubscriptionAdjustmentTable from "./subscriptionAdjustmentTable";
import Input from "../../../component/inputpm";
import Loader from "../../../component/loader";
import ResendDialog from "../order/resendDialog";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Select from "@mui/material/Select";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../component/breadcrumb";
import Tooltip from "@mui/material/Tooltip";
import Paper from "@mui/material/Paper";
import { IconButton } from "@mui/material";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
} from "../../../component/icons/icons";
import Button from "../../../component/button";
import { Grid } from "@mui/material";
import dateFormat from "dateformat";

// Manage order page class
class SubscriptionAdjustments extends Component {
  // Declare property values that belongs to the component
  state = {
    subscriptionAdjustments: [],
    adjustment: {},
    subAdjustmentId: "",
    subscriptionId: "",
    name: "",
    subscriberLastName: "",
    status: "",
    isEdit: false,
    subscriptionStatus: "",
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalOrderCount: 0,
    loading: true,
    actionOrderId: "",
    isMailDialog: false,
    sortBy: "adjustmentId",
    sortOrder: "DESC",
    controls: true,
    tenant: "",
    statusList: [],
    categoryList: [],
    typeList: [],
    isSubscriptionDialog: false,
    tenantList: [],
    bread: [
      {
        title: this.props.t("SUBSCRIPTION_ADJUSTMENTS"),
        url: "/subscriptionadjustments",
      },
    ],
    showLoading: true,
    categoryId: "",
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ADJUSTMENT_STATUSES/endpoint`,
      {},
    )
      .then((res) => {
        let list = res.data;
        let all = {
          name: "All Adjustments",
          value: "All Adjustments",
        };
        list.unshift(all);
        this.setState({
          statusList: res.data,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ADJUSTMENT_CATEGORIES/endpoint`,
      {},
    )
      .then((res) => {
        let list = res.data;
        console.log("categories===", list);
        let all = {
          name: "Adjustment Categories",
          value: "Adjustment Categories",
        };
        list.unshift(all);
        this.setState({
          categoryList: res.data,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
    this.getAdjustmentTypes();
    this.callGetAdjustments();
  }

  getAdjustmentTypes = (categoryId) => {
    console.log("categoryId==", categoryId);
    if (categoryId != undefined) {
      this.setState({
        categoryId: categoryId,
      });
    }
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ADJUSTMENT_TYPES/endpoint?categoryId=${this.state.categoryId}`,
      {},
    )
      .then((res) => {
        let list = res.data;
        let all = {
          name: "Adjustment Types",
          value: "Adjustment Types",
        };
        list.unshift(all);
        this.setState({
          typeList: res.data,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  callGetAdjustments = () => {
    let initialFilters = JSON.parse(localStorage.getItem("adjustmentFilters"));
    if (initialFilters) {
      this.setState(
        {
          rowsPerPage: initialFilters.rowsPerPage,
          startRecord: initialFilters.startRecord,
          page: initialFilters.page,
          sortBy: initialFilters.sortBy,
          sortOrder: initialFilters.sortOrder,
          subAdjustmentId: initialFilters.subAdjustmentId,
          subscriptionId: initialFilters.subscriptionId,
          name: initialFilters.name,
          subscriptionStatus: initialFilters.subscriptionStatus,
        },
        () => {
          this.getSubscriptionAdjustments();
        },
      );
    } else {
      this.getSubscriptionAdjustments();
    }
  };

  getSubscriptionAdjustments = () => {
    this.setState({
      loading: true,
      showLoading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    let adjustmentFilters = {
      rowsPerPage: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
      page: this.state.page,
      sortBy: this.state.sortBy,
      sortOrder: this.state.sortOrder,

      subAdjustmentId: this.state.subAdjustmentId,
      subscriptionId: this.state.subscriptionId,
      name: this.state.name,
      subscriptionStatus:
        this.state.subscriptionStatus === "All Adjustments"
          ? ""
          : this.state.subscriptionStatus,
    };
    localStorage.setItem(
      "adjustmentFilters",
      JSON.stringify(adjustmentFilters),
    );

    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/subscriptionAdjustments?adjustmentId=${this.state.subAdjustmentId}&subscriptionId=${this.state.subscriptionId}&name=${this.state.name}&statusId=${adjustmentFilters.subscriptionStatus}`,
      {},
      pageOptions,
    )
      .then((res) => {
        console.log("data===", res);
        let data = res.data;
        if (data.length > 0) {
          this.setState({
            subscriptionAdjustments: data,
            totalOrderCount: +res.headers["x-total-count"],
            loading: false,
            showLoading: false,
          });
        } else {
          this.setState({
            subscriptionAdjustments: [],
            totalOrderCount: 0,
            loading: false,
            showLoading: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // Update state data on input change
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Open resend confirmation email modal
  openResendDialog = (orderId) => {
    this.setState({
      isMailDialog: true,
    });
  };

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getSubscriptionAdjustments();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getSubscriptionAdjustments();
      },
    );
  };

  // Close confirmation email dialog
  closeMailDialog = () => {
    this.setState({
      isMailDialog: false,
    });
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getSubscriptionAdjustments();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getSubscriptionAdjustments();
        },
      );
    }
  };

  // Search/Filter orders
  filterAdjustmentTable = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
        subAdjustmentId: this.state.subAdjustmentId,
        name: this.state.name,
        subscriptionId: this.state.subscriptionId,
        subscriptionStatus: this.state.subscriptionStatus,
        status: this.state.status,
        subscriberLastName: this.state.subscriberLastName,
      },
      () => {
        this.getSubscriptionAdjustments();
      },
    );
  };

  // Clear all search filters
  clearAdjustmentTableSearch = () => {
    this.setState(
      {
        subAdjustmentId: "",
        name: "",
        subscriptionId: "",
        status: "",
        subscriptionStatus: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getSubscriptionAdjustments();
      },
    );
  };

  // Clear all search filters and refeesh data
  refreshAdjustmentTableSearch = () => {
    this.setState(
      {
        subAdjustmentId: "",
        name: "",
        subscriptionId: "",
        status: "",
        subscriptionStatus: "",
        page: 1,
        startRecord: 1,
        sortBy: "subAdjustmentId",
        sortOrder: "DESC",
      },
      () => {
        this.getSubscriptionAdjustments();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterAdjustmentTable();
    }
  };

  handleClickOpen = () => {
    this.setState({
      isSubscriptionDialog: true,
    });
  };

  handleClose = () => {
    this.setState({
      isSubscriptionDialog: false,
      isEdit: false,
    });
  };

  handleEdit = (adjustment) => {
    console.log("clicked");
    this.setState({
      isSubscriptionDialog: true,
      isEdit: true,
      adjustment: adjustment,
    });
  };

  closeEdit = () => {
    this.setState({
      isEdit: false,
    });
  };

  // Render order view
  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              <Grid
                item
                style={{ textAlign: "right" }}
                size={{
                  xs: 6,
                }}
              >
                {
                  /*Pratyush - Check if the user has the new Subscription Adjustment Permission*/
                  // <Button onClick={this.handleClickOpen}>{this.props.t('NEW_SUBSCRIPTION_ADJUSTMENT')}</Button>
                }
              </Grid>
            </Grid>
          </div>
        </div>
        <div style={{ position: "relative" }}>
          <Paper className="tablePaper">
            {/* Search filters start */}
            <div className={classes.searchOuterDiv}>
              <div className={classes.searchInputDiv}>
                <Input
                  size={"medium"}
                  variant={"outlined"}
                  placeholder={t("SUB_ADJUSTMENT_ID")}
                  value={this.state.subAdjustmentId}
                  name={"subAdjustmentId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div className={classes.searchInputDiv}>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("SUBSCRIPTION_ID")}
                  value={this.state.subscriptionId}
                  name={"subscriptionId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div className={classes.searchInputDiv}>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("ADJUSTMENT_NAME")}
                  value={this.state.name}
                  name={"name"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div
                className={classes.searchInputDiv}
                style={{ maxWidth: "250px" }}
              >
                <Select
                  native
                  size={"small"}
                  variant={"outlined"}
                  name={"subscriptionStatus"}
                  inputProps={{
                    name: "subscriptionStatus",
                    id: "outlined-native-subscriptionStatus",
                  }}
                  //value={(a) => a.value}
                  value={this.state.subscriptionStatus}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                  selectClass={
                    classes.inputClass +
                    " " +
                    classes.statusSelectBg +
                    " " +
                    classes.searchOrderSelect
                  }
                >
                  {this.state.statusList.map((a) => (
                    <option key={a.value} value={a.value}>
                      {a.value}
                    </option>
                  ))}
                </Select>
              </div>

              {/* <div className={classes.searchOrderLabelOuter}>
                                <div className={classes.searchOrderLabelInner}> */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Tooltip title={t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.filterAdjustmentTable}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.clearAdjustmentTableSearch}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={t("REFRESH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.refreshAdjustmentTableSearch}
                  >
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {/* </div> */}
              {/* <div className='cl'></div> */}
            </div>
            {/* Search filters end */}

            {/* Subscription Adjustment table component */}
            <SubscriptionAdjustmentTable
              subAdjustmentId={this.state.subAdjustmentId}
              subscriptionId={this.state.subscriptionId}
              name={this.state.name}
              subscriptionAdjustments={this.state.subscriptionAdjustments}
              openResendDialog={this.openResendDialog}
              rowsPerPage={this.state.rowsPerPage}
              totalOrderCount={this.state.totalOrderCount}
              page={this.state.page}
              sortBy={this.state.sortBy}
              sortOrder={this.state.sortOrder}
              updateSorting={this.updateSorting}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              controls={this.state.controls}
              loggedInUserType={this.props.loggedInUserType}
              showLoading={this.state.showLoading}
              edit={this.handleEdit}
            />
          </Paper>

          {/* Resend confirmation dialog component */}
          <ResendDialog
            isOpen={this.state.isMailDialog}
            close={this.closeMailDialog}
            orderId={this.state.actionOrderId}
          />
          {/* <SubscriptionDialog
                        isOpen={this.state.isSubscriptionDialog}
                        close={this.handleClose}
                        getSubscriptionAdjustments={this.getSubscriptionAdjustments}
                        isEdit={this.state.isEdit}
                        edit={this.handleEdit}
                        closeEdit={this.closeEdit}
                        adjustment={this.state.adjustment}
                        onChange={this.onChange}
                        categoryList={this.state.categoryList}
                        typeList={this.state.typeList}
                        getAdjustmentTypes={this.getAdjustmentTypes}
                    /> */}
          <Loader loading={this.state.loading} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
    menuPaths: state.auth.menuPaths,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(SubscriptionAdjustments));
